// Estados del pedido (01-especificacion.md §3). Las Cloud Functions aplican las transiciones;
// aquí están los textos para la interfaz y las reglas que la interfaz necesita conocer.

export type EstadoPedido =
  | "ESPERANDO_PAQUETE"
  | "BUSCANDO_DOMICILIARIO"
  | "ASIGNADO"
  | "EN_CAMINO"
  | "ENTREGADO"
  | "CERRADO"
  | "CANCELADO"
  | "INCIDENTE";

export type Tono = "espera" | "activo" | "ok" | "alerta" | "neutro";

export const ESTADOS_PEDIDO: Record<EstadoPedido, { etiqueta: string; tono: Tono }> = {
  ESPERANDO_PAQUETE: { etiqueta: "Esperando que llegue", tono: "espera" },
  BUSCANDO_DOMICILIARIO: { etiqueta: "Buscando domiciliario", tono: "espera" },
  ASIGNADO: { etiqueta: "Domiciliario va a garita", tono: "activo" },
  EN_CAMINO: { etiqueta: "En camino a tu puerta", tono: "activo" },
  ENTREGADO: { etiqueta: "Entregado", tono: "ok" },
  CERRADO: { etiqueta: "Cerrado", tono: "neutro" },
  CANCELADO: { etiqueta: "Cancelado", tono: "neutro" },
  INCIDENTE: { etiqueta: "Con incidente", tono: "alerta" },
};

/** Transiciones permitidas. Las Cloud Functions (functions/src) son las que las aplican. */
export const TRANSICIONES: Record<EstadoPedido, EstadoPedido[]> = {
  ESPERANDO_PAQUETE: ["BUSCANDO_DOMICILIARIO", "CANCELADO"],
  BUSCANDO_DOMICILIARIO: ["ASIGNADO", "CANCELADO"],
  ASIGNADO: ["EN_CAMINO", "BUSCANDO_DOMICILIARIO", "CANCELADO"],
  EN_CAMINO: ["ENTREGADO", "INCIDENTE"],
  ENTREGADO: ["CERRADO", "INCIDENTE"],
  CERRADO: [],
  CANCELADO: [],
  INCIDENTE: ["CERRADO"],
};

export function puedeTransicionar(desde: EstadoPedido, hacia: EstadoPedido): boolean {
  return TRANSICIONES[desde].includes(hacia);
}

/** HU-08: el residente cancela sin costo antes de que el paquete salga de garita. */
export function residentePuedeCancelar(estado: EstadoPedido): boolean {
  return estado === "ESPERANDO_PAQUETE" || estado === "BUSCANDO_DOMICILIARIO" || estado === "ASIGNADO";
}

export function pedidoActivo(estado: EstadoPedido): boolean {
  return !["ENTREGADO", "CERRADO", "CANCELADO", "INCIDENTE"].includes(estado);
}

export type TipoPaquete = "COMIDA" | "PAQUETE" | "MERCADO" | "DOCUMENTO" | "OTRO";
export type TamanoPaquete = "S" | "M" | "L";

export const TIPOS_PAQUETE: Record<TipoPaquete, string> = {
  COMIDA: "Comida",
  PAQUETE: "Paquete",
  MERCADO: "Mercado",
  DOCUMENTO: "Documento",
  OTRO: "Otro",
};

export const TAMANOS_PAQUETE: Record<TamanoPaquete, string> = {
  S: "Pequeño",
  M: "Mediano",
  L: "Grande",
};

export type Rol = "RESIDENTE" | "DOMICILIARIO" | "VIGILANTE" | "ADMIN";
export type EstadoMembresia = "PENDIENTE" | "APROBADO" | "RECHAZADO" | "DESHABILITADO";
export type VinculoUnidad = "INQUILINO" | "PROPIETARIO_RESIDENTE" | "PROPIETARIO_NO_RESIDENTE";
export type VinculoDomiciliario = "EMPLEADO_CONJUNTO" | "EMPLEADO_TIENDA" | "RESIDENTE";

export const ROLES: Record<Rol, string> = {
  RESIDENTE: "Residente",
  DOMICILIARIO: "Domiciliario",
  VIGILANTE: "Vigilante",
  ADMIN: "Administración",
};

export const VINCULOS_UNIDAD: Record<VinculoUnidad, string> = {
  INQUILINO: "Inquilino",
  PROPIETARIO_RESIDENTE: "Propietario, vivo aquí",
  PROPIETARIO_NO_RESIDENTE: "Propietario, no vivo aquí",
};

export const VINCULOS_DOMICILIARIO: Record<VinculoDomiciliario, string> = {
  EMPLEADO_CONJUNTO: "Empleado del conjunto",
  EMPLEADO_TIENDA: "Empleado de la tienda interna",
  RESIDENTE: "Residente del conjunto",
};

export const ESTADOS_MEMBRESIA: Record<EstadoMembresia, string> = {
  PENDIENTE: "Pendiente",
  APROBADO: "Habilitada",
  RECHAZADO: "Rechazada",
  DESHABILITADO: "Deshabilitada",
};
